import { useEffect, useRef } from 'react';

// The classic Konami Code sequence: ↑ ↑ ↓ ↓ ← → ← → B A
const KONAMI_CODE = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'KeyB',
  'KeyA',
];

export const useKonamiCode = (callback: () => void) => {
  const keysRef = useRef<string[]>([]);

  useEffect(() => {
    // Only run on client side
    if (typeof window === 'undefined') return;

    const handleKeyDown = (event: KeyboardEvent) => {
      // Only capture the key presses, don't prevent default behavior
      keysRef.current = [...keysRef.current, event.code];

      // Keep only the last 10 keys to match the Konami code length
      keysRef.current = keysRef.current.slice(-KONAMI_CODE.length);

      // Check if the recent keys match the Konami code
      if (keysRef.current.length === KONAMI_CODE.length) {
        const matches = keysRef.current.every((key, index) => key === KONAMI_CODE[index]);

        if (matches) {
          callback();
          keysRef.current = [];
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [callback]);

  // Reset function to clear the current sequence
  const reset = () => {
    keysRef.current = [];
  };

  return { reset };
};
